import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Lock, LogOut } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { AdminProducts } from '../components/admin/AdminProducts';
import { AdminOrders } from '../components/admin/AdminOrders';
import { AdminSettings } from '../components/admin/AdminSettings';
import { AdminSurveys } from '../components/admin/AdminSurveys';
import { API } from '../lib/shop';

export default function Admin() {
  const [authed, setAuthed] = useState(!!sessionStorage.getItem('adminKey'));
  const [password, setPassword] = useState('');
  const [tab, setTab] = useState('settings');

  const login = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/shop/admin/login`, { password });
      sessionStorage.setItem('adminKey', password);
      setAuthed(true);
    } catch {
      toast.error('Incorrect password');
    }
  };

  const logout = () => { sessionStorage.removeItem('adminKey'); setAuthed(false); setPassword(''); };

  if (!authed) {
    return (
      <div className="min-h-screen pt-32 pb-20 px-4 bg-gray-50" data-testid="admin-login-page">
        <form onSubmit={login} className="max-w-sm mx-auto bg-white rounded-2xl border border-gray-200 p-8 space-y-4">
          <div className="w-12 h-12 rounded-full bg-pink-100 text-pink-600 flex items-center justify-center mx-auto"><Lock className="w-6 h-6" /></div>
          <h1 className="text-2xl font-bold text-gray-900 text-center">Admin login</h1>
          <Input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Admin password" required data-testid="admin-password-input" />
          <Button type="submit" className="w-full bg-pink-500 hover:bg-pink-600 text-white" data-testid="admin-login-button">Sign in</Button>
        </form>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-28 pb-20 px-4 bg-gray-50" data-testid="admin-page">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Admin</h1>
          <div className="flex items-center gap-3">
            <Link to="/quotes" className="text-sm text-pink-600 hover:underline" data-testid="admin-quotes-link">Quote requests</Link>
            <Button variant="outline" size="sm" onClick={logout} data-testid="admin-logout"><LogOut className="w-4 h-4 mr-1" /> Log out</Button>
          </div>
        </div>
        <div className="flex gap-2 mb-6 border-b">
          {['settings', 'surveys', 'products', 'orders'].map(t => (
            <button key={t} onClick={() => setTab(t)} data-testid={`admin-tab-${t}`} className={`px-4 py-2 font-medium capitalize border-b-2 -mb-px ${tab === t ? 'border-pink-500 text-pink-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`}>{t}</button>
          ))}
        </div>
        {tab === 'settings' && <AdminSettings />}
        {tab === 'surveys' && <AdminSurveys />}
        {tab === 'products' && <AdminProducts />}
        {tab === 'orders' && <AdminOrders />}
      </div>
    </div>
  );
}
